import { render, staticRenderFns } from "./AgreementWrapper.vue?vue&type=template&id=92387c56&"
import script from "./AgreementWrapper.vue?vue&type=script&lang=js&"
export * from "./AgreementWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports